import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { dateFormatWithTime } from "utils/dateFormat";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import { getUserReferralApi } from "services/referral";
import { IoMdArrowRoundBack } from "react-icons/io";
import { SearchBar } from "components/form";
import useDebounce from "common/UseDebounce";
const Referral = ({ UserDetail = {}, showHeader = true }) => {
  const { userId } = useParams();
  const [referralList, setReferralList] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [total, setTotal] = useState(null);
  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  const [loader, onShow, onHide] = useFullPageLoader();
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  // Referral list handler
  const userReferralListHandler = async (currentUserId) => {
    try {
      onShow();
      const query = {
        page: activePage,
        limit: 10,
        // search,
        id: currentUserId,
      };

      if (debouncedValue) {
        query.search = debouncedValue;
      }
      const res = await getUserReferralApi(query);
      if (res?.data?.status === 200) {
        setTotal(res.data.data.total);
        setReferralList(res.data?.data?.users);
        onHide();
      } else {
        toastMessage(res?.data?.message, "error", "userReferralListHandler");
      }
    } catch (e) {
      onHide();
      toastMessage(e.message, "error", "userReferralListHandler");
    }
  };

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    const Id = UserDetail?.user?._id || userId;
    userReferralListHandler(Id);
  }, [activePage, limit, UserDetail?.user?._id, userId, debouncedValue]);

  return (
    <div className="student_management">
      {showHeader && (
        <div className="dashboard_title">
          <h3>
            <Link to={"/user-management"}>
              <IoMdArrowRoundBack />
            </Link>
            Referral Details
          </h3>
          <div className="d-flex"></div>
          <div className="button_section_wrap">
            <div className="search_wrapper">
              <SearchBar
                className="referral-search"
                placeholder={"Search..."}
                onChange={(e) => {
                  setSearch(e.target.value);
                  searchParams.delete("page");
                  setSearchParams(searchParams);
                }}
                value={search}
              />
            </div>
          </div>
        </div>
      )}
      <div className="card">
        <div className="card-body">
          <div className="table_wrap ">
            <table className="table custom_table">
              <thead>
                <tr>
                  <th className="nowrap">S.no</th>
                  <th className="nowrap">Name</th>
                  <th className="nowrap">Email</th>
                  <th className="nowrap">Referral Date</th>
                  {/* <th className="nowrap">Referral Code Used</th> */}
                </tr>
              </thead>
              <tbody>
                {loader}
                {referralList && referralList?.length > 0 ? (
                  referralList?.map((data, index) => {
                    return (
                      <tr key={++index}>
                        <td className="nowrap">{index + 1}</td>
                        <td className="nowrap">{data?.name || ""}</td>
                        <td className="nowrap">{data?.email || ""}</td>
                        <td>{dateFormatWithTime(data?.createdAt)}</td>
                        {/* <td>{data?.referralCode || "N/A"}</td> */}
                      </tr>
                    );
                  })
                ) : (
                  <NotFound
                    cols={7}
                    msg={"User Referral data not found"}
                    onHide={onHide}
                  />
                )}
              </tbody>
            </table>
          </div>
          {total > limit && (
            <div className="pagination-wrapper">
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={limit}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                  hideDisabled={true}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Referral;
